<template>
    <div class="solution">
      <div class="main">
        <div class="bg1">
          <div class="model1">
            <p class="position">您所在的位置：首页 > 智慧警务</p>
            <p class="title">公安警务系统</p>
            <p class="title2"></p>
            <div class="title-text">随着经济社会的全面发展，大数据时代的来临，公安业务范围也在不断扩大；单一、片面的数据信息已无法满足公安系统办公需求。</div>
            <div class="title-text">作为一个城市的治安维护和交通管理部门，必须涵盖整个辖区内的视频监控信息，同时要确保对视频监控信息的实时监控、调用、管理。指挥中心的整体运行效果直接影响对城市交通管理与社会治安管理工作的顺利开展。</div>
            <div class="img"><img class="scale":src="url + '/assets/policeWork/police-system.png'"></div>
          </div>
        </div>
        <div class="bg2">
          <div class="model4">
            <p class="title">公安警务系统应用需求</p>
            <div class="title2"></div>
            <div class="list">
              <div class="listData" v-for="(img,index) in listData" :key="index" >
                <img :class="{ img1: index == 0, img2: index == 1, img3: index == 2 , img4: index == 3, img5: index == 4, img6: index == 5}" :src="img.img">
                <p class="p1">{{img.title}}</p>
                <p class="p1">{{img.title1}}</p>
              </div>
            </div>
          </div>
         </div>
         <div class="bg1">
            <div class="model5">
              <p class="title">解决方案</p>
              <div class="title2"></div>
              <div class="model1-main">
                <div class="left">
                  <div class="p">可靠的系统组成</div>
                  <div class="p1">公安交通可视化指挥中心系统由雅典娜视频综合平台硬件、雅典娜视频综合平台软件、视频矩阵、RGB矩阵等附属的外围组成。</div>
                </div>
                <div class="right">
                  <img class="scale" :src="url + '/assets/policeWork/police-solution1.png'">
                </div>
              </div>
              <div class="model2-main">
                <div class="right">
                  <img class="scale" :src="url + '/assets/policeWork/police-solution2.png'">
                </div>
                 <div class="left">
                  <div class="p">可靠的系统组成</div>
                  <div class="p1">公安交通可视化指挥中心系统由雅典娜视频综合平台硬件、雅典娜视频综合平台软件、视频矩阵、RGB矩阵等附属的外围组成。</div>
                </div>
              </div>
              <div class="model1-main">
                <div class="left">
                  <div class="p">多方联动调度指挥</div>
                  <div class="p1">公安超高清智能可视化指挥调度平台依托于雅典娜视频综合平台显示系统，与公安系统已有的PGIS系统、GPS系统、“三台合一”接处警系统和治安视频监控系统进行对接，实现了快速、高效、灵活、“图上作业方式”的联动调度指挥。</div>
                </div>
                <div class="police-solution3">
                  <img class="scale" :src="url + '/assets/policeWork/police-solution3.png'">
                </div>
              </div>
            </div>
         </div>
         <div class="bg2">
          <div class="model4">
            <p class="title">公安警务系统九大功能</p>
            <div class="title2"></div>
            <div class="list1">
              <img :src="url + '/assets/policeWork/police-function1.png'">
              <img :src="url + '/assets/policeWork/police-function2.png'">
              <img :src="url + '/assets/policeWork/police-function3.png'">
              <img :src="url + '/assets/policeWork/police-function4.png'">
            </div>
             <div class="list2">
              <img :src="url + '/assets/policeWork/police-function5.png'">
              <img :src="url + '/assets/policeWork/police-function6.png'">
              <img :src="url + '/assets/policeWork/police-function7.png'">
              <img :src="url + '/assets/policeWork/police-function8.png'">
              <img :src="url + '/assets/policeWork/police-function9.png'">
            </div>
          </div>
         </div>
      </div>
      <foot></foot>
    </div>
</template>
<script>
import defaultSettings from '@/defaultSettings'
const img1 = defaultSettings.url + '/assets/policeWork/police-demand1.png'
const img2 = defaultSettings.url + '/assets/policeWork/police-demand2.png'
const img3 = defaultSettings.url + "/assets/policeWork/police-demand3.png"
const img4 = defaultSettings.url + "/assets/policeWork/police-demand4.png"
const img5 = defaultSettings.url + "/assets/policeWork/police-demand5.png"
const img6 = defaultSettings.url + "/assets/policeWork/police-demand6.png"
import foot from '../components/foot'
export default {
  data() {
    return {
      url: defaultSettings.url,
      listData: [
        {
          img: img1,
          title: '模拟监控系统、',
          title1: '网络监控系统混合应用'
        },
         {
          img: img2,
          title: '警力',
          title1: '分散难以合理调配'
        },
         {
          img: img3,
          title: '传统的',
          title1: '视频调用操作繁琐'
        },
         {
          img: img4,
          title: '系统间',
          title1: '无法相互配合'
        },
         {
          img: img5,
          title: '警力调度',
          title1: '不灵活，效率低'
        },
         {
          img: img6,
          title: '警力资源',
          title1: '类型及分布效率低'
        }
      ]
    }
  },
  components: {
    foot
  },
    mounted() {
    window.scrollTo({ left: 0, top: 0 })
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
.bg1{
  background: #F9F9F9;
}
.bg2{
  background: #fff;
}
.title{
  color:#333;
  font-size:34px;
  text-align: left;
}
.title2:after {
  display: block;
  content: "";
  height: 0;
  line-height: 0;
  visibility: hidden;
  clear: both;
}
.title2 {
  zoom: 1; /* 为了兼容IE */
}
.title2{
  width: 87px;
  height: 3px;
  background: #167EFB;
  text-align: left;
  margin:30px 0 25px;
  display: block;
}
// 缩放
.scale{
    width:100%;
    transition: all 0.6s;
}
.scale:hover{
    transition: all 0.6s;
    transform: scale(1.08);
}

.solution{
  padding-top:140px;
  background: #F9F9F9;
  .main{
    .model1{
        margin-top:84px;
        width:1200px;
        margin: 0 auto;
        padding-bottom:90px;
        .position{
          margin-top:25px;
          color:#999999;
          font-size:14px;
          margin-bottom:50px;
        }
        .title{
          color:#333;
          font-size:34px;
          text-align: center;
        }
        .title2{
          width: 87px;
          height: 3px;
          background: #167EFB;
          text-align: center;
          margin:30px auto 60px;
        }
        .title-text{
          width:960px;
          text-align: center;
          margin:0 auto;
          color:#333;
          font-size:14px;
          line-height: 30px;
        }
        .img{
          width:1200px;
          height:360px;
          margin-top:50px;
          img{
            width:1200px;
            height:360px;
          }
        }
    }
    .model4{
      width:1200px;
      margin: 0px auto 86px;
      padding-top:90px;
      .list{
        padding-bottom:80px;
        .listData{
          width:33%;
          text-align: center;
          display: inline-block;
          margin-top:50px;
          .img1{
            width:60px;
            height:52px;
            margin-bottom:25px;
          }
          .img2{
            width:58px;
            height:56px;
            margin-bottom:25px;
          }
          .img3{
            width:58px;
            height:52px;
            margin-bottom:25px;
          }
          .img4{
            width:47px;
            height:56px;
            margin-bottom:25px;
          }
          .img5{
            width:58px;
            height:58px;
            margin-bottom:25px;
          }
          .img6{
             width:58px;
            height:58px;
            margin-bottom:25px;
          }
          .p1{
            color:#333;
            font-size:18px;
            margin-bottom:7px;
          }
        }
      }
      .list1{
        margin:0 150px;
        img{
          margin:0 22px;
          width:170px;
          height:195px;
        }
      }
      .list2{
        margin:-35px 40px 0;
        img{
          margin:0 22px;
          width:170px;
          height:195px;
        }
      }
    }
     .model5{
      width:1200px;
      margin: 0px auto;
      padding-top:90px;
      .model1-main{
        padding-bottom:95px;
        display: flex;
        .left{
          width:528px;
          margin-top:30px;
          .p{
            font-size:26px;
            color:#333;
            margin-bottom:30px;
            line-height: 30px;
          }
          .p1{
            margin-bottom:15px;
            line-height: 30px;
            color:#333;
            font-size:16px;
          }
        }
        .right{
            margin-left:105px;
            width:567px;
            height:200px;
          img{
            width:567px;
            height:200px;
          }
        }
        .police-solution3{
          width:579px;
          height:164px;
          margin-left:105px;
          img{
            width:579px;
            height:164px;
          }
        }
      }
      .model2-main{
        padding-bottom:95px;
        display: flex;
        .left{
          width:528px;
          margin-top:30px;
          .p{
            font-size:26px;
            color:#333;
            margin-bottom:30px;
            line-height: 30px;
          }
          .p1{
            margin-bottom:15px;
            line-height: 30px;
            color:#333;
            font-size:16px;
          }
        }
        .right{
            margin-right:105px;
            width:443px;
            height:290px;
          img{
             width:443px;
            height:290px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/policeWork.vue